import React from 'react';
import { Card, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { FilterAltOutlined, FilterAltOffOutlined, PlayCircleFilled } from '@mui/icons-material';
import { Account } from '../../../sp-types/accountTypes';
import { Material } from '../../../sp-types';

interface Props {
  filters: { account: string; material: string; type: string };
  setFilters: (_filters: any) => void;
  checkAllRules: () => void;
  accounts: Account[];
  materials: Material[];
  notificationTypes: { value: string; label: string }[];
  onAddRule: () => void;
}
export const NotificationBar: React.FC<Props> = ({
  filters,
  setFilters,
  checkAllRules,
  accounts = [],
  materials = [],
  notificationTypes = [],
  onAddRule,
}) => {
  const getHandler = (key: keyof typeof filters) => (e: any) => setFilters({ ...filters, [key]: e.target.value || '' });

  return (
    <Card className="flex flex-row gap-4 align-top h-12 m-1 p-2 shadow-custom justify-between">
      <div className="flex gap-3">
        Filters
        <FilterAltOutlined />
        <FormControl>
          <InputLabel shrink>Account</InputLabel>
          <Select
            className="h-8 w-40"
            displayEmpty
            value={filters.account}
            onChange={getHandler('account')}
            label="_______"
          >
            <MenuItem value="">
              <em className="text-gray-450">All Accounts</em>
            </MenuItem>
            {accounts.map((a) => (
              <MenuItem key={a.id} value={a.id}>
                {a.id}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel shrink>Material</InputLabel>
          <Select
            className="w-60 h-8"
            displayEmpty
            value={filters.material}
            onChange={getHandler('material')}
            label="_______"
          >
            <MenuItem value="">
              <em className="text-gray-450">All materials</em>
            </MenuItem>
            {materials.map((m) => (
              <MenuItem key={m.id} value={m.id}>
                {m.name} ({m.id})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel shrink>Type</InputLabel>
          <Select className="h-8 w-40" displayEmpty value={filters.type} onChange={getHandler('type')} label="____">
            <MenuItem value="">
              <em className="text-gray-450">All types</em>
            </MenuItem>
            {notificationTypes.map((t) => (
              <MenuItem key={t.value} value={t.value}>
                {t.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={() => setFilters({ account: '', material: '', type: '' })}
          variant="outlined"
          disabled={!filters.account && !filters.material && !filters.type}
        >
          <FilterAltOffOutlined />
        </Button>
      </div>
      <div className="flex gap-3">
        <Button onClick={checkAllRules} variant="contained">
          <PlayCircleFilled /> Check All
        </Button>
        <Button onClick={onAddRule} variant="contained">
          Add Rule
        </Button>
      </div>
    </Card>
  );
};
